import React, { useState } from 'react';
import LangA from '../../../i18n/LangA';
import ChevronDown from '../../../images/navigation/chevron-down.png';
import ChevronUp from '../../../images/navigation/chevron-up.png';
import cx from 'classnames';

const NavListItem = ({ href, linkText, title, titleId, subMenu, img, iconId }, idx) => {
  const [activeSubmenuId, setActiveSubmenuId] = useState('');

  return (
    <div key={`sub_${idx}`} className={`nav__dropdown-list-item mobile_nav_li`}>
      {!subMenu && (
        <LangA className="mobile-link-small padding-large" id={titleId} href={href} title={title}>
          {linkText}
        </LangA>
      )}
      {subMenu && (
        <div
          role="button"
          tabIndex={0}
          className="nav__dropdown-mobile-list-wrapper padding-large"
          onClick={() => {
            if (activeSubmenuId === titleId) {
              setActiveSubmenuId('');
            } else {
              setActiveSubmenuId(titleId);
            }
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              if (activeSubmenuId === titleId) {
                setActiveSubmenuId('');
              } else {
                setActiveSubmenuId(titleId);
              }
            }
          }}
        >
          <span className={cx(img ? 'flex-start' : '', 'image-wrapper')}>
            <span>
              {img && (
                <div className="mobile-nav-icon-container">
                  <img id={iconId} className={`nav__dropdown-item-img `} src={img} alt={title} />
                </div>
              )}
              {linkText}
            </span>
            {activeSubmenuId === titleId ? (
              <img src={ChevronUp} alt="Chevron up" width="13" />
            ) : (
              <img src={ChevronDown} alt="Chevron down" width="13" />
            )}
          </span>

          <div
            style={{ display: activeSubmenuId === titleId ? 'flex' : 'none' }}
            className={cx(img ? 'ms-4' : '', 'nav__dropdown-mobile-list-submenu')}
          >
            {subMenu?.map((item, idx) => (
              <LangA key={`${titleId}-${idx}`} id={item.titleId} href={item.href} title={item.title}>
                {item.linkText}
              </LangA>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NavListItem;
